import "./ClinkPage.css";
import { t } from "../../services/formatters";
import { Button } from "../../components/Button";
// import { Riepilogo } from "../../components/Riepilogo";
import { Breadcrumb } from "../../components/Breadcrumb";
import { Informative } from "../../components/Informative";
import { FormDatiUtente } from "../../components/FormDatiUtente";
import { ClinkButton } from "../../components/ClinkButton";
import { useClinkPage } from "./useClinkPage";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";
import { useComponentMetric } from "../../lib/otel";

export const ClinkPage = () => {
  const { next, read, vuoleRicontatto, setVuoleRicontatto, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError, isCreaAppuntamentoBusy } = useClinkPage();

const metric = useComponentMetric("clink");
  useEffect(() => {
    window.dataLayer.push({
      event: "customPageview",
      virtualPageURL: "/fa3/fissa-appuntamento/clink",
      crmIdentification: read("utenteRiconosciuto") && read("utenteRiconosciuto") == true ? "utente riconosciuto" : "nuovo utente",
      privacy_mtk_consent: "",
      funnelVersion: "nuovo",
      capFiliale: read("cap"),
      presa_info: read("solo_info"),
    });
  }, []);

  useEffect(() => {
    if (fetchError) {
      metric.trackError(fetchErrorMessage || "errore creazione appuntamento");
    }
  }, [fetchError]);


  return (
    <div id="clink-page">
      <Breadcrumb />

      {/* clink buttons */}
      <div className={`section`}>
        <h2 className="bold text-left">Una comoda soluzione per te!</h2>
        <div className="text-left">Vuoi fissare un incontro con un nostro consulente dove preferisci tu?</div>

        <div className="section flex-row centered-content text-center clink_yes_no">
          <ClinkButton
            type="yes"
            onClick={() => {
              setVuoleRicontatto(true);
            }}
            active={vuoleRicontatto}
          />
          <ClinkButton
            type="no"
            onClick={() => {
              setVuoleRicontatto(false);
            }}
            active={!vuoleRicontatto}
          />
        </div>

        {vuoleRicontatto ? <div>Nelle prossime ore verrai contattato da un nostro consulente per fissare un appuntamento dove preferisci.</div> : "" /*<Riepilogo showTitle={false} />*/}
      </div>

      {!vuoleRicontatto && <FormDatiUtente title={t("compila_dati")} />}

      {!vuoleRicontatto && <Informative />}

      <div className="section text-center">
        <Button
          id="go-to-select-state-btn"
          disabled={false}
          onClick={next}
          classList="btn-responsive always-style"
          loading={isCreaAppuntamentoBusy()}
          text={vuoleRicontatto ? t("avanti") : t("fissa_appuntamento")}
        />
      </div>

      <ErrorModal
        open={fetchError}
        text={fetchErrorMessage}
        onCloseModal={() => {
          setFetchError(false);
        }}></ErrorModal>
    </div>
  );
};
